<template>
  <div class="dialog_contents">
    <ul>
      <li class="item">
        <div class="item_text">
          <span><span style="color:red">*</span>标题：</span>
          <el-input v-model="title1" style="width:200px;"></el-input>
        </div>
        <div class="item_text">
          <span><span style="color:red">*</span>类型：</span>
          <el-select v-model="type1" placeholder="请选择" clearable>
            <el-option v-for="(item,index) in typeList" :key="index" :label="item.valueDesc" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </li>
      <li class="item_text">
        <textarea id="contractTemplate"></textarea>
      </li>
    </ul>
    <div class="dialog-footer">
      <el-button @click="removeTemplate">取 消</el-button>
      <el-button v-points type="primary" @click="saveTemplate">确 定</el-button>
    </div>
  </div>
</template>

<script>
import imageConversion from 'image-conversion';
import { dicGet } from "@/api";
import {
  queryNotice,
  addNotice,
  updateNotice,
  deleteNotice
} from "@/api/manageCenter";
import tinymce from "tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/themes/silver/";
import "tinymce/plugins/image";
import "tinymce/plugins/imagetools";
import "tinymce/plugins/link";
import "tinymce/plugins/code";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/contextmenu";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/colorpicker";
import "tinymce/plugins/textcolor";
import "tinymce/plugins/print";
import "tinymce/plugins/preview";
import "../../assets/tinymce/plugins/lineheight/plugin";
export default {
  props: ["title", "type", "content", "id"],
  data() {
    return {
      type1: "",
      title1: "",
      typeList: []
    };
  },
  mounted() {
    this.init();
    this.getType();
    this.type1 = this.type;
    this.title1 = this.title;
    setTimeout(() => {
      tinyMCE.activeEditor.setContent(this.content);
    }, 1000);
  },

  methods: {
    //提交公告
    saveTemplate() {
      if(!this.title1){
        this.$message.error("标题不能为空");
        return;
      }
      if(!this.type1){
        this.$message.error("请选择类型");
        return;
      }
      let params = {
        id: this.id,
        title: this.title1,
        type: this.type1
      };
      params.content = tinyMCE.activeEditor.getContent();
      if (this.title) {
        this.$post(updateNotice, params).then(res => {
          if (res.success) {
            this.$message({
              type: "success",
              message: res.msg
            });
            this.$emit("saveTem");
          } else {
            this.$message({
              type: "error",
              message: res.msg
            });
          }
        });
      } else {
        this.$post(addNotice, params).then(res => {
          if (res.success) {
            this.$message({
              type: "success",
              message: res.msg
            });
            this.$emit("saveTem");
          } else {
            this.$message({
              type: "error",
              message: res.msg
            });
          }
        });
      }
    },
    //取消公告
    removeTemplate() {
      this.$emit("removeTem");
    },
    //查询类型
    getType() {
      let params = {
        code: "noticeType"
      };
      this.$post(dicGet, params).then(res => {
        if (res.success) {
          this.typeList = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg
          });
        }
      });
    },
    init() {
      tinymce.init({
        selector: "#contractTemplate",
        // images_upload_handler: (blobInfo, success, failure) => {
        //   const formData = new FormData();
        //   formData.append("file", blobInfo.blob());
        //   let queryDetailKey = "/erp/qiniu/uploadImg";
        //   this.$post(queryDetailKey, formData, true).then(res => {
        //     success("http://" + res.uri);
        //   });
        // },
        images_upload_handler: (blobInfo, success, failure) => {
          const formData = new FormData();
          let file = blobInfo.blob();
          let isLt2M = file.size / 1024 / 1024 < 0.48; // 判定图片大小是否小于2MB
          let isLt2M1 = file.size / 1024 / 1024 > 8; // 判定图片大小是否小于2MB
          if (isLt2M1) {
            this.$message.error('上传图片大小不能超过8MB!');
            success("");
            return;
          }
          if (!isLt2M) {
            // 压缩到300KB,这里的300就是要压缩的大小,可自定义
            imageConversion.compressAccurately(file, 300).then(res => {
              file = res;
              console.log(file);
              formData.append("file", file);
              let queryDetailKey = "/erp/qiniu/uploadImg";
              this.$post(queryDetailKey, formData, true).then(res => {
                success("http://" + res.uri);
              });
            });
          } else {
            console.log(file);
            formData.append("file", file);
            let queryDetailKey = "/erp/qiniu/uploadImg";
            this.$post(queryDetailKey, formData, true).then(res => {
              success("http://" + res.uri);
            });
          }
          // formData.append("file", blobInfo.blob());
          // let queryDetailKey = "/erp/qiniu/uploadImg";
          // this.$post(queryDetailKey, formData, true).then(res => {
          //   success("http://" + res.uri);
          // });
        },
        branding: false,
        elementpath: false,
        width: "100%",
        height: 550,
        skin_url: `/tinymce/skins/ui/oxide`,
        language_url: `/tinymce/zh_CN.js`,
        language: "zh_CN",
        menubar: "edit format table",
        fontsize_formats:
          "5pt 5.5pt 6.5pt 7.5pt 9pt 10.5pt 12pt 14pt 15pt 16pt 18pt 22pt 24pt 26pt 36pt 44pt 46pt 48pt 50pt 52pt 54pt",
        lineheight_val: "0.5 1 1.5 1.6 1.75 1.8 2 3 4 5",
        font_formats:
          "微软雅黑='微软雅黑';宋体='宋体';黑体='黑体';仿宋='仿宋';楷体='楷体';隶书='隶书';幼圆='幼圆';Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Symbol=symbol;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;Webdings=webdings;Wingdings=wingdings",
        plugins: ["code lineheight wordcount print preview image"],
        toolbar:
          "preview | undo redo | lineheight | forecolor backcolor bold italic underline | fontsizeselect fontselect | alignleft aligncenter alignright alignjustify | image",
        autosave_interval: "20s",
        save_enablewhendirty: false,
        image_advtab: true,
        table_default_styles: {
          width: "100%",
          height: "100%",
          borderCollapse: "collapse"
        }
      });
    }
  },
  //离开销毁
  destroyed() {
    tinyMCE.editors["contractTemplate"].destroy();
  }
};
</script>

<style lang='less'>
.dialog_contents {
  .dialog-footer {
    width: 100%;
    line-height: 100px;
    margin: 10px 20px 20px;
    text-align: right;
  }
  .item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    &_text {
      display: flex;
      align-items: center;
      .el-input__inner {
        height: 30px;
      }
      .el-input__icon {
        line-height: 30px;
      }
      span {
        width: 50px;
      }
    }
    &_text:first-child {
      .el-input__inner {
        width: 500px;
      }
    }
  }
}
</style>